import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import {PageLayout} from '../../../common/look';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFileInvoice} from '@fortawesome/free-solid-svg-icons/faFileInvoice';
import {faPortrait} from '@fortawesome/free-solid-svg-icons/faPortrait';
import {flowRight as compose} from 'lodash';
import TabPage from '../../../common/components/layout/TabPage';
import {withTranslation} from 'react-i18next';
import config from '../../../config/app';
import MerchantDetails from './MerchantTabs/MerchantDetails';
import {Link} from 'react-router-dom';
import {SpanGoBack} from '../../brand/components/UserBrandDetails';
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import MerchantBillingDetails from './MerchantTabs/MerchantBillingDetails';
import MerchantCheckoutsDetails from './MerchantTabs/MerchantCheckoutsDetails';
import MerchantTicketsDetails from './MerchantTabs/MerchantTicketsDetails';
import {withRouter} from 'react-router';
import {faCashRegister, faReceipt} from '@fortawesome/free-solid-svg-icons';


const renderMetaData = t => (
  <Helmet
    title={`${config.name} - ${t('title')}`}
    meta={[{name: 'description', content: `${config.name} - ${t('meta')}`}]}
  />
);

const MerchantDetailView = ({t, match}) => {

  const merchantId = match.params.id;

  const tabs = [
    {
      header: (
        <>
          <FontAwesomeIcon icon={faPortrait} color="rgb(201,0,95)" />
          {` ${t('details')}`}
        </>
      ),
      content: <MerchantDetails merchantId={merchantId} />,
    },
    {
      header: (
        <>
          <FontAwesomeIcon icon={faFileInvoice} color="rgb(201,0,95)" />
          {` ${t('billing')}`}
        </>
      ),
      content: <MerchantBillingDetails merchantId={merchantId} />,
    },
    {
      header: (
        <>
          <FontAwesomeIcon icon={faCashRegister} color="rgb(201,0,95)" />
          {` ${t('checkouts')}`}
        </>
      ),
      content: <MerchantCheckoutsDetails merchantId={merchantId} />,
    },
    {
      header: (
        <>
          <FontAwesomeIcon icon={faReceipt} color="rgb(201,0,95)" />
          {` ${t('tickets')}`}
        </>
      ),
      content: <MerchantTicketsDetails merchantId={merchantId} />,
    },
  ];

  const leadingTab = (
    <Link to={'/admin/merchants'} title={t('goBackToMerchants')}>
      <SpanGoBack><FontAwesomeIcon icon={faArrowLeft} color={'rgb(201,0,95)'}/></SpanGoBack>
    </Link>
  );

  return (
    <PageLayout>
      {renderMetaData(t)}
      <TabPage tabs={tabs} leading={leadingTab}/>
    </PageLayout>
  );
};

MerchantDetailView.propTypes = {
  t: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    }).isRequired,
  }).isRequired,
};

export default compose(
  withTranslation('merchant'),
  withRouter,
)(MerchantDetailView);
